<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4" >
      <b-form> 

          <b-row>
              <b-col cols="1" class="mt-2 pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         
                        class="mb-2" 
                        v-model="operador.foto"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="operador.foto"
                    >
                    </b-img>
                  </b-form-group>
                  
              </b-col>  
             
              <b-col>

                <!-- NOME -->     
                <b-row >
                    <b-col cols=7 class="mt-3 ">
                        <b-form-input id="fot-nome" 
                            type="text" 
                            readonly                       
                            v-model="operador.nome"                         
                            placeholder="Nome funcionário" 
                        />                        
                    </b-col>
                    


                </b-row>


                <!-- FUNÇÃO e CHN -->     
                <b-row >
                   
                    <b-col cols=2 class="mt-2">
                        <b-form-input id="fot-funcao" 
                            type="text"   
                            readonly                     
                            v-model="operador.funcao"                         
                            placeholder="Função" 
                        />                        
                    </b-col>

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly   
                            v-mask="'#####-###'"                     
                            v-model="operador.celular"                         
                            placeholder="Celular" 
                        />
                    </b-col>                       

                    <b-col cols=4 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="operador.cnh_cat"                         
                            placeholder="CNH" 
                        />
                    </b-col>   
                                                                  
                </b-row>

                <!-- RE e CELULAR -->     
                <b-row >
                    <b-col cols=3 class="mt-4">
                        <b-form-input id="fot-re" 
                            type="text"
                            required                        
                            v-model="operador.re" 
                            @keyup.enter="loadOperador()"                        
                            placeholder="1818" 
                        />                        
                    </b-col> 
                    
                    <b-col cols=2 class="mt-4">
                        <div>   
                                <b-form-datepicker id="esc_data_servico"  required v-model="data_inicial"  placeholder="Data inicial" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                            </div>                     
                    </b-col>                 

                    <b-col cols=2 class="mt-4">
                        <div>   
                                <b-form-datepicker id="esc_data_servico2"  required v-model="data_final"  placeholder="Data final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                            </div>                     
                    </b-col>                 


                    <b-col cols=1 class="mt-4">
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadFichaPonto()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>                      
                </b-col>
             
                </b-row>

                            


              </b-col>              
          </b-row>

          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="618px"  :items="escala" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import moment from 'moment'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            carregando: false,
            operadores:{},
            operador: [],            
            marcacao:[],
            data_inicial: '',
            data_final: '',




            mainProps: { blankColor: '#777', width: 157, height: 161, class: 'm1' },


            
            fields: [
                

                { key: 're', label: 'Data Servico', sortable: true, formatter: (value, key, marcacao) => {
                    return moment( marcacao.re ).format('DD/MM/YYYY');} }, 

                { key: 'a', label: 'Marcação 1', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.a).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'b', label: 'Marcação 2', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.b).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'c', label: 'Marcação 3', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.c).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'd', label: 'Marcação 4', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.d).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'e', label: 'Marcação 5', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.e).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'f', label: 'Marcação 6', sortable: true, formatter: (value, key, marcacao) => {
                    return moment(marcacao.f).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },

                



                
            ]
        }        
    },


    methods: {

        async loadOperador() { 
            let corpo = {                             
            "re": `${this.operador.re}`                      
            }; 
            
          const url = `${baseApiUrl}/escala/consulta/`
          axios.post(url,corpo).then(res => { this.operador = res.data })   
                      this.carregando = false;       
                      this.marcacao = []
        },  

        async loadFichaPonto() {                                 
            let corpo = {                
            "re": `${this.operador.re}` ,                     
            "dt_inicial": `${this.data_inicial}`,                  
            "dt_final": `${this.data_final}`                      
          }; 

          const url = `${baseApiUrl}/pontoeletronico/fichaponto`
          axios.post(url,corpo)            
          .then(res => {
            this.carregando = false;               
            this.escala = res.data 
            })          
        .catch(showError)
            
        }, 



        
       
    },

    mounted() { 
       // this.loadFormatarData()
       //this.loadOperador()           
       //this.loadEscalaServico()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>

